import React, { useEffect, useState,Fragment } from 'react';
import { isEmpty } from "lodash"
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getPhotoShop } from '../../../../../../jsx/actions/shopAction';
import { createInstall, validatePrepa, deletePrepa, deleteInstall } from '../../../../../../jsx/actions/saleAction';
import { createClient } from '../../../../../../jsx/actions/clientAction';
import Spin from '../../../commonModules/interface/Spin';
import { CardLayout, BreadCrumb } from './containers/Layout';
import ListInstallItem from './installs/ListInstallItem.jsx';
import ListInstall from './installs/ListInstall.jsx';
import Form from './installs/Form.jsx';
import SingleInstall from './installs/SingleInstall.jsx';
import SingleShop from './shops/SingleShop';
import { Button, Card, Grid, Box, IconButton } from '@material-ui/core';
import { ListRounded, ListAltRounded } from '@material-ui/icons';
import CardPage from '../../../commonModules/layouts/CardPage';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
// import FormInstallToSale from './installs/FormInstallToSale';
import AccordionFilter from './Filter/AccordionFilter';
import ListTransferInstall from './transfers/installs/ListTransferInstall';
import SingleTransferInstall from './transfers/installs/SingleTransferInstall';
import FormTransfreInstallToSale from './transfers/installs/FormTransfreInstallToSale';
import { toast } from 'react-toastify';
//import { fetchTransferDetails } from '../../../../../../jsx/actions/transferAction';

const Installations = (props) => {
    const [state, setState] = useState({        
        view: props.new ? "new" : "list",
        listview: "sale",

        singleShop:{},
        singleInstall:{
            sale:{},
            shop:{},
            client:{},
        },
        breadcrumb: "",
        currentPage: 0,
        currentPageProd: 0,
        rowsPerPage: 20,

        selectShop:"",
        searchType: "",
        searchClient: "",
        searchFacture: "",
        searchProduct: "", 
    })
 
    useEffect(() => {
        if(isEmpty(props.AGENTS)){
            props.fetchAgents()
        }
    }, []);

    // select options 
    const createShopList = () => {
            const list = [{value:"", label:"Tous les Magasins"}]
            const { SHOPS } = props
            if( !isEmpty(SHOPS) ){
                Object.values(SHOPS).forEach( shop => { 
                    list.push (       
                        {value:shop.id, label:shop.name} 
                    )
                })
            } 
            return list
        }
    const createClientList = () => {
            const list = [{value:"", label:"Tous les Clients"}]
            const { CLIENTS } = props
            if( CLIENTS ){
                Object.values(CLIENTS).map(client => { 
                    list.push (       
                        {value:client.id, label:client.client_lastname} 
                    )
                })
            } 
            return list
        }
    const normalizeStr = (str) => {// remove accent and lower case str
            if (str){
                console.log("str exist", {str}, isEmpty(str));
                str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
            }
            return str
        }
    const prodFilter = (prodID) => {
            const { PRODUCTS } = props;
            const { searchProduct } = state
    
            let product = PRODUCTS[prodID]
            let searching = searchProduct ? normalizeStr(searchProduct) : ""
    
            const productName = product ? normalizeStr(product.name) : ""
            const productRef = product ? normalizeStr(product.ref) : ""
            const productType = product ? normalizeStr(product.type) : ""
            const productBrand = product ? normalizeStr(product.marque) : ""
    
            return ( 
                productName.indexOf(searching) !== -1 ||
                productRef.indexOf(searching) !== -1 ||
                productType.indexOf(searching) !== -1 ||
                productBrand.indexOf(searching) !== -1
            )  
        }

    const handleChange = (e) => {
            const { name, value } = e.target;
            setState(prevState => ({...prevState,
                [name]: value,
                currentPage: 0,
                currentPageProd: 0,
            }))
        }
    const handleSelect = (option, name) => {
        setState(prevState => ({...prevState,
                [name]: option.value, 
                currentPage: 0,
                currentPageProd: 0,
            }))
        } 

    const getFilteredList = () => {
            const { INSTALLS } = props;
            const { selectShop, searchClient, searchFacture, searchType } = state;
            
            let list = Object.values(INSTALLS)
            // status
            var received
            if (typeof received == "boolean"){
                list = list.filter(item => item.received == received)
            }
            // client
            if (!isEmpty(searchClient)) {
                list = list.filter(item => item.client_ref === searchClient || item.sale_paygo_id === searchClient )
                // list = list.filter(item => filterClients(item))
            }
            // shop
            if(!isEmpty(selectShop)){
                list = list.filter(item => item.shop_id === selectShop)
            }
            // fact
            if(!isEmpty(searchFacture)){
                const normalizeRef = (s) => (s || '').toString().toLowerCase().replace(/[-/\s_]/g, '');
                const search = normalizeRef(searchFacture);
                list = list.filter(item =>
                    normalizeRef(item.id).indexOf(search) > -1 ||
                    normalizeRef(item.intern_ref_id).indexOf(search) > -1
                );
            }

            return list
        }
    // CLEAR & DISPLAY
    const handleClose = () => {
        setState(prevState => ({...prevState,
                view:"list",
                breadcrumb: "",
                singleInstall:{
                    sale:{},
                    shop:{},
                    client:{},
                },
            }));
            // clearForms()
        }
    const handleSingleInstall = (sale, shop, client) => {
        setState(prevState => ({...prevState,
                view:"sale",
                breadcrumb:`Installation n°${sale.id}`,
                singleInstall:{sale, shop, client},
            }))
        }
    const handleInstallToSale = (sale, client) => {
            console.log('================ INSTALL TO SALE ====================');
            console.log("IN handleInstallToSale");
            console.log('====================================');
            setState(prevState => ({...prevState,
                view:"newSale",
                breadcrumb:`Installation n°${sale.id}`,
                singleInstall:{sale, client},
            }))
        }



    const handleSingleShop = (shop) => {
        setState(prevState => ({...prevState,
                breadcrumb: shop.name,
                singleShop:shop,
                view: "shop"
            }))
        }
    const onChangePage = (pageOfItems, page, rowsPerPage) => {
        setState(prevState => ({...prevState,
            currentPage:page, rowsPerPage }));
        }
    const onChangePageProd = (pageOfItemsProd, page , rowsPerPage) => {
        setState(prevState => ({...prevState,
            currentPageProd:page , rowsPerPage}));
        }

        let shops = createShopList()
        let clients = createClientList()

        return(
            <CardPage title="Installations" storehouse action={
                <Box>
                    {state.view === "list" &&
                    <Fragment>
                        <Button color="primary" variant="contained"
                            onClick={ ()=>  setState(prevState => ({...prevState,view: "new", breadcrumb:"Nouveau"})) }
                        > Nouvelle Installation </Button>
                        {state.listview === "sale" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Produits"
                                onClick={()=> setState(prevState => ({...prevState,view: "list", listview: "prodList" })) }
                            >
                                <ListRounded />
                            </IconButton>
                        }
                        {state.listview === "prodList" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Installations"
                                onClick={()=> setState(prevState => ({...prevState, view: "list", listview: "sale" })) }
                            >
                                <ListAltRounded />
                            </IconButton>
                        }

                    </Fragment>
                    }
                </Box>
            }>
                <BreadCrumb breadcrumb={ state.breadcrumb } title="Installations" back={handleClose} />
                {state.view === "new" &&
                    <Form {...props} handleClose={ handleClose } />
                }
                {state.view === "newSale" &&
                    <FormTransfreInstallToSale
                        {...props} 
                        install={state.singleInstall.sale} 
                        client={state.singleInstall.client} 
                        handleClose={ handleClose }
                    />
                }
                {state.view === "updateInstallation" &&
                    <Form 
                    {...props}
                    install={state.singleInstall.sale} 
                    update 
                    handleClose={ handleClose } />
                }
                {state.view === "sale" &&
                    <SingleTransferInstall 
                        install={state.singleInstall.sale} 
                        shop={state.singleInstall.shop} 
                        client={state.singleInstall.client} 
                        handleInstallToSale={handleInstallToSale}
                        {...props} 
                        getPhoto={props.getPhoto} 
                    />
                }
                {state.view === "shop" &&
                    <SingleShop shop={state.singleShop} {...props} />
                }
                  
                {state.view === "list" &&
                // {state.view === "list" && (state.listview === "sale" ||  state.listview === "prodList") &&
                <AccordionFilter>
                    <Grid container >
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={shops}
                                value={state.selectShop}
                                label="Sélectionner un Magasin"
                                onChange={(option) => handleSelect(option, "selectShop") }
                            /> 
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={clients}
                                value={state.searchClient}
                                label="Client"
                                onChange={(option) => handleSelect(option, "searchClient") }
                            /> 
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputText
                                label="Facture"
                                value={state.searchFacture}
                                name="searchFacture"
                                onChange={handleChange}
                            /> 
                        </Grid>
                        {state.listview === "prodList" &&
                        <Grid item xs={12} md={6}>
                            <InputText 
                                name="searchProduct" 
                                value={state.searchProduct} 
                                placeholder="Rechercher par produit " 
                                label="Rechercher"
                                onChange={ handleChange} 
                            />
                        </Grid>
                        }
                    </Grid>
                </AccordionFilter>
                }
                {props.STATE.installs.fetching && <Spin noOverlay />}
               
                {state.view === "list" && state.listview === "sale" &&
                <Box>                    
                    {/* {!isEmpty(props.INSTALLS) && */}
                        <ListTransferInstall 
                        // <ListInstall 
                            {...props}
                            {...state}
                            onChangePage={onChangePage}
                            handleInstallToSale={handleInstallToSale}  
                            handleSingleShop={handleSingleShop}  
                            handleSingleInstall={handleSingleInstall}  
                            getFilteredList={getFilteredList}  
                            prodFilter={prodFilter}  
                        />
                    {/* } */}
                </Box>
                }
                {state.view === "list" && state.listview === "prodList" &&
                <Box> 
                    {!isEmpty(props.INSTALLS) &&
                        <ListInstallItem
                            {...props}
                            {...state}
                            onChangePage={onChangePageProd}
                            handleSingleShop={handleSingleShop}  
                            handleSingleInstall={handleSingleInstall}  
                            getFilteredList={getFilteredList}  
                            prodFilter={prodFilter}  
                        />
                    }
                </Box>
                }
            </CardPage>
        )
}


// function mapStateToProps(state){// transform elements from store's state into props in this component
//     return {
//         state: state.inventory.requestState.installs,
//         stateClient: state.inventory.requestState.clients,
//     }
// }

export default Installations